import firebase from 'firebase';
import { ENVIRONMENT } from '.';



const production = {
    apiKey: "AIzaSyBWJlAawC0mf0NjwqQwWHk2bLAdV2sM7Zw",
    authDomain: "pubpoints-97683.firebaseapp.com",
    projectId: "pubpoints-97683",
    storageBucket: "pubpoints-97683.appspot.com",
    messagingSenderId: "264771563980",
    appId: "1:264771563980:web:f202e98eaf8c64814a6d69",
    measurementId: "G-MF07LS9KKR"
};

const staging = {
    apiKey: "AIzaSyCQ8QBkPwunQmwhC66B7PfRQwzIA8YaS-s",
    authDomain: "pubpoints-staging.firebaseapp.com",
    projectId: "pubpoints-staging",
    storageBucket: "pubpoints-staging.appspot.com",
    messagingSenderId: "819629495895",
    appId: "1:819629495895:web:ec201aca3b8419b30cf512",
    measurementId: ""
}


const development = {
    apiKey: "AIzaSyDTk52_WBPMjZQNDc9DhRKKhIP7WkJumDY",
    authDomain: "pubpoints-dev.firebaseapp.com",
    projectId: "pubpoints-dev",
    storageBucket: "pubpoints-dev.appspot.com",
    messagingSenderId: "849514207329",
    appId: "1:849514207329:web:bec9069047aebbb8b33220",
    measurementId: "G-R9PR9MFD8Y"
}

const initializeFirebaseApp = () => {
    console.log("initializing app...", ENVIRONMENT)

    let config = development;

    if (ENVIRONMENT === 'production') {
        config = production;
    } else if(ENVIRONMENT === 'staging') {
        config = staging;
    }

    firebase.initializeApp(config);
}


export const dbRef = firebase.firestore
export const storageRef = firebase.storage


export default initializeFirebaseApp;


